import { render, staticRenderFns } from "./ParagraphStructureTree.vue?vue&type=template&id=7b6d9a2a&"
import script from "./ParagraphStructureTree.vue?vue&type=script&lang=js&"
export * from "./ParagraphStructureTree.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphStructureTree.vue?vue&type=style&index=0&id=7b6d9a2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports